import { Flex, Text } from '@chakra-ui/react';
import { faCalendar, faClock } from '@fortawesome/pro-regular-svg-icons';
import { faFile } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Accordion } from '@morressier/alembic';
import { IRevisionRound } from '@publishing-engine/domain/models';
import dateFormat from 'dateformat';
import MultilineText from 'src/components/MultilineText';
import FileViewerButtonText from 'src/components/Submission/FileViewerButtonText';
import { AdjudicatorFeedback } from 'src/components/Submission/MySubmission/components/feedback/AdjudicatorFeedback';
import { ReviewerFeedback } from 'src/components/Submission/MySubmission/components/feedback/ReviewerFeedback';
import TextWithIcon from 'src/components/TextWithIcon';
import { useSubmissionData } from 'src/contexts/SubmissionDataProvider';
import { timeFormatDeadlineDate } from 'src/utils/date';
interface Props {
  revisionRound: IRevisionRound;
}
const RevisionRequest: React.FC<Props> = ({ revisionRound }) => {
  const {
    workflowResponse: {
      submissionId,
      workflowData: { currentDeadline, dateEnteredCurrentPhase }
    }
  } = useSubmissionData();
  return (
    <Accordion
      chakraAccordionProps={{
        allowMultiple: true,
        width: '100%',
        background: 'surfacePrimaryFill'
      }}
      items={[
        {
          title: (
            <Flex direction={'column'} gap={1}>
              <Text textStyle={'headingGroup'} id="Revision request">
                Revision request
              </Text>
              <Flex textStyle={'textBody'} gap={2}>
                {dateEnteredCurrentPhase && (
                  <TextWithIcon
                    icon={faCalendar}
                    text={`Received ${dateFormat(
                      dateEnteredCurrentPhase,
                      'mmm d, yyyy'
                    )}`}
                  />
                )}
                |
                <TextWithIcon
                  icon={faClock}
                  text={`Deadline ${timeFormatDeadlineDate(
                    currentDeadline ?? ''
                  )}`}
                />
              </Flex>
            </Flex>
          ),
          content:
            revisionRound && !revisionRound?.editorialDecision ? (
              <>
                {revisionRound.editorialComment && (
                  <Flex gap={2} flexDirection={'column'} mb={2}>
                    <Text textStyle="headingLine">Editor’s comment</Text>
                    <MultilineText
                      textStyle="textBody"
                      text={revisionRound.editorialComment}
                    />
                  </Flex>
                )}
                {revisionRound.editorialAttachments &&
                  revisionRound.editorialAttachments.length > 0 && (
                    <Flex gap={2} flexDirection={'column'}>
                      <Text textStyle="headingLine">Editor’s attachments</Text>
                      <Flex flexDirection="column" gap={0}>
                        {' '}
                        {revisionRound.editorialAttachments.map(file => (
                          <Flex
                            justifyContent="space-between"
                            key={file?.referenceName}
                          >
                            <Flex gap={2} alignItems="center">
                              <FontAwesomeIcon icon={faFile} />
                              <Text textStyle="textBody">
                                {file?.referenceName}
                              </Text>
                              <FileViewerButtonText
                                file={file}
                                submissionContextId={submissionId}
                                textStyle="textBody"
                                flexShrink={0}
                              >
                                View
                              </FileViewerButtonText>
                            </Flex>
                          </Flex>
                        ))}
                      </Flex>
                    </Flex>
                  )}
                {(() => {
                  const reviewerFeedback = !revisionRound
                    .reviewerRevisionFeedback?.length
                    ? revisionRound.reviewerOriginalFeedback ?? []
                    : revisionRound.reviewerRevisionFeedback;

                  return (
                    <ReviewerFeedback
                      reviewerFeedback={reviewerFeedback}
                      submissionContextId={submissionId}
                    />
                  );
                })()}

                {(() => {
                  const adjudicatorFeedback = revisionRound
                    .adjudicatorOriginalFeedback?.length
                    ? revisionRound.adjudicatorOriginalFeedback
                    : [];

                  return (
                    <AdjudicatorFeedback
                      adjudicatorFeedback={adjudicatorFeedback}
                      submissionContextId={submissionId}
                    />
                  );
                })()}
              </>
            ) : null
        }
      ]}
    />
  );
};

export default RevisionRequest;
